import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'

@Pipe({
    name: 'localtime'
})
export class LocalTimePipe implements PipeTransform {
    transform(value: number, args?: any): string {

        return moment.utc(value).local().format('YYYY-MM-DD HH:mm:ss');
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/local-time.pipe.ts